import React, { useState, useEffect } from "react";

export function DebugPanel() {
  const [debugInfo, setDebugInfo] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchDebugInfo = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch("/.netlify/functions/debug-env");
      if (!response.ok) {
        throw new Error(`HTTP error ${response.status}`);
      }
      const data = await response.json();
      setDebugInfo(data);
      console.log("Debug info:", data);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Unknown error");
      console.error("Error fetching debug info:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 bg-volt-deep-blue border border-volt-blue/30 rounded-lg mt-4">
      <h2 className="text-lg font-bold text-volt-blue mb-2">
        Environment Debug
      </h2>

      <button
        onClick={fetchDebugInfo}
        disabled={loading}
        className="px-4 py-2 bg-volt-blue text-white rounded-md mb-4 hover:bg-volt-blue/80 transition-colors"
      >
        {loading ? "Loading..." : "Check Environment"}
      </button>

      {error && (
        <div className="p-3 bg-red-500/20 text-red-500 rounded-md mb-4">
          Error: {error}
        </div>
      )}

      {debugInfo && (
        <div className="space-y-4 text-sm">
          <div>
            <h3 className="font-semibold text-volt-green mb-1">
              Environment Variables
            </h3>
            <pre className="bg-black/30 p-2 rounded overflow-auto">
              {JSON.stringify(debugInfo.environment, null, 2)}
            </pre>
          </div>

          <div>
            <h3 className="font-semibold text-volt-green mb-1">
              Supabase Connection
            </h3>
            <pre className="bg-black/30 p-2 rounded overflow-auto">
              {JSON.stringify(debugInfo.supabase, null, 2)}
            </pre>
          </div>

          <div>
            <h3 className="font-semibold text-volt-green mb-1">
              env_vars Table
            </h3>
            <pre className="bg-black/30 p-2 rounded overflow-auto">
              {JSON.stringify(debugInfo.envVarsTable, null, 2)}
            </pre>
          </div>

          {debugInfo.error && (
            <div className="p-3 bg-red-500/20 text-red-500 rounded-md">
              Error: {debugInfo.error}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
